



























































import { Component, Vue, Prop } from "vue-property-decorator";
import { ProjectDailyPerformance } from "@/models/project";

@Component({ name: "ProjectPerformanceDailyCarousel" })
export default class ProjectPerformanceDailyCarousel extends Vue {
  @Prop() readonly perfs!: Array<ProjectDailyPerformance>;

/*  created() {
    //  const car: any = this.$refs.theCarousel
    //  car.setSlide(20)
    //(this.$refs.theCarousel as Vue & { setSlide: (index: number) => boolean }).setSlide(20)
  }*/

  get thePerformances() {
    return this.perfs
  }

}
